// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/organizations/firstparty/v1/update_organization.proto

/* eslint-disable */
import { ApiOrganizationInput } from "./create_organization";
import { ApiOrganization } from "./organization";

/** Request message for updating an organization */
export interface ApiUpdateOrganizationRequest {
  /** The ID of the organization to update */
  readonly id: string;
  /** The organization data to update */
  readonly organization: ApiOrganizationInput | null;
}

/** Response message for updating an organization */
export interface ApiUpdateOrganizationResponse {
  /** The updated organization */
  readonly organization: ApiOrganization | null;
}

/** Error codes for UpdateOrganization operation */
export interface ApiUpdateOrganizationErrors {
}

/** Not found error codes */
export const ApiUpdateOrganizationErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Organization not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiUpdateOrganizationErrorsNotFoundError =
  typeof ApiUpdateOrganizationErrorsNotFoundError[keyof typeof ApiUpdateOrganizationErrorsNotFoundError];

export namespace ApiUpdateOrganizationErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiUpdateOrganizationErrorsNotFoundErrorFromJSON(
  object: any,
): ApiUpdateOrganizationErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateOrganizationErrorsNotFoundErrorToJSON(
  object: ApiUpdateOrganizationErrorsNotFoundError,
): string {
  switch (object) {
    case ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiUpdateOrganizationErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Method not allowed error codes */
export const ApiUpdateOrganizationErrorsMethodNotAllowedError = {
  /** METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED - Unspecified method not allowed error */
  METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED: "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED",
  /** METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT - Organization must be in draft status to be updated */
  METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT: "METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT",
} as const;

export type ApiUpdateOrganizationErrorsMethodNotAllowedError =
  typeof ApiUpdateOrganizationErrorsMethodNotAllowedError[
    keyof typeof ApiUpdateOrganizationErrorsMethodNotAllowedError
  ];

export namespace ApiUpdateOrganizationErrorsMethodNotAllowedError {
  export type METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED =
    typeof ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
  export type METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT =
    typeof ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT;
}

export function apiUpdateOrganizationErrorsMethodNotAllowedErrorFromJSON(
  object: any,
): ApiUpdateOrganizationErrorsMethodNotAllowedError {
  switch (object) {
    case 0:
    case "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED":
      return ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
    case 1:
    case "METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT":
      return ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT;
    default:
      return ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateOrganizationErrorsMethodNotAllowedErrorToJSON(
  object: ApiUpdateOrganizationErrorsMethodNotAllowedError,
): string {
  switch (object) {
    case ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED:
      return "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED";
    case ApiUpdateOrganizationErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT:
      return "METHOD_NOT_ALLOWED_ERROR_ORGANIZATION_NOT_IN_DRAFT";
    default:
      return "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED";
  }
}

/** Bad request error codes */
export const ApiUpdateOrganizationErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_UNSPECIFIED - Unspecified bad request error */
  BAD_REQUEST_ERROR_UNSPECIFIED: "BAD_REQUEST_ERROR_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_VALIDATION_FAILED - Validation failed */
  BAD_REQUEST_ERROR_VALIDATION_FAILED: "BAD_REQUEST_ERROR_VALIDATION_FAILED",
} as const;

export type ApiUpdateOrganizationErrorsBadRequestError =
  typeof ApiUpdateOrganizationErrorsBadRequestError[keyof typeof ApiUpdateOrganizationErrorsBadRequestError];

export namespace ApiUpdateOrganizationErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_UNSPECIFIED =
    typeof ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_VALIDATION_FAILED =
    typeof ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
}

export function apiUpdateOrganizationErrorsBadRequestErrorFromJSON(
  object: any,
): ApiUpdateOrganizationErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_UNSPECIFIED":
      return ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_VALIDATION_FAILED":
      return ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
    default:
      return ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateOrganizationErrorsBadRequestErrorToJSON(
  object: ApiUpdateOrganizationErrorsBadRequestError,
): string {
  switch (object) {
    case ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
    case ApiUpdateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED:
      return "BAD_REQUEST_ERROR_VALIDATION_FAILED";
    default:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
  }
}

export const ApiUpdateOrganizationRequest: MessageFns<ApiUpdateOrganizationRequest> = {
  fromJSON(object: any): ApiUpdateOrganizationRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      organization: isSet(object.organization) ? ApiOrganizationInput.fromJSON(object.organization) : null,
    };
  },

  toJSON(message: ApiUpdateOrganizationRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.organization !== undefined && message.organization !== null) {
      obj.organization = ApiOrganizationInput.toJSON(message.organization);
    }
    return obj;
  },
};

export const ApiUpdateOrganizationResponse: MessageFns<ApiUpdateOrganizationResponse> = {
  fromJSON(object: any): ApiUpdateOrganizationResponse {
    return { organization: isSet(object.organization) ? ApiOrganization.fromJSON(object.organization) : null };
  },

  toJSON(message: ApiUpdateOrganizationResponse): unknown {
    const obj: any = {};
    if (message.organization !== undefined && message.organization !== null) {
      obj.organization = ApiOrganization.toJSON(message.organization);
    }
    return obj;
  },
};

export const ApiUpdateOrganizationErrors: MessageFns<ApiUpdateOrganizationErrors> = {
  fromJSON(_: any): ApiUpdateOrganizationErrors {
    return {};
  },

  toJSON(_: ApiUpdateOrganizationErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
